import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import * as yup from 'yup';

import { validateWithYupSchema } from '@hrlogics/react-form-utils/yup';

import { Button } from 'src/components/common';
import { Field, Form, TextField } from 'src/components/finalForm';

export const TextInputSection: React.FC = () => {
  return (
    <Box component="section">
      <Typography variant="h3">Text Input</Typography>
      <Box mt={2}>
        <Form
          initialValues={initialValue}
          onSubmit={submitHandler}
          subscription={{ dirty: true }}
          validate={validateWithYupSchema(formValidationSchema)}
        >
          {({ form, dirty }) => (
            <React.Fragment>
              <Grid container spacing={2}>
                <Grid size={6}>
                  <Field
                    name={FormFieldId.emptyInput}
                    component={TextField}
                    fullWidth
                    label="Empty input"
                  />
                </Grid>
                <Grid size={6}>
                  <Field
                    name={FormFieldId.emptyInputDisabled}
                    component={TextField}
                    fullWidth
                    label="Empty input"
                    disabled
                  />
                </Grid>

                <Grid size={6}>
                  <Field
                    name={FormFieldId.inputRequired}
                    component={TextField}
                    fullWidth
                    label="Empty input (required)"
                    required
                  />
                </Grid>
                <Grid size={6}>
                  <Field
                    name={FormFieldId.inputRequiredDisabled}
                    component={TextField}
                    fullWidth
                    label="Empty input (required)"
                    required
                    disabled
                  />
                </Grid>

                <Grid size={6}>
                  <Field
                    name={FormFieldId.inputWithText}
                    component={TextField}
                    fullWidth
                    label="Label"
                  />
                </Grid>
                <Grid size={6}>
                  <Field
                    name={FormFieldId.inputWithTextDisabled}
                    component={TextField}
                    fullWidth
                    label="Label"
                    disabled
                  />
                </Grid>

                <Grid size={6}>
                  <Field
                    name={FormFieldId.inputWithTextInvalid}
                    component={TextField}
                    fullWidth
                    label="Label"
                    required
                    showErrorOnlyTouched={false}
                  />
                </Grid>
                <Grid size={6}>
                  <Field
                    name={FormFieldId.inputWithTextInvalidDisabled}
                    component={TextField}
                    fullWidth
                    label="Label"
                    disabled
                    required
                    showErrorOnlyTouched={false}
                  />
                </Grid>
              </Grid>

              <Box mt={2}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => form.restart()}
                  disabled={!dirty}
                >
                  Reset
                </Button>
              </Box>
            </React.Fragment>
          )}
        </Form>
      </Box>
    </Box>
  );
};

enum FormFieldId {
  emptyInput = 'emptyInput',
  emptyInputDisabled = 'emptyInputDisabled',
  inputRequired = 'inputRequired',
  inputRequiredDisabled = 'inputRequiredDisabled',
  inputWithText = 'inputWithText',
  inputWithTextDisabled = 'inputWithTextDisabled',
  inputWithTextInvalid = 'inputWithTextInvalid',
  inputWithTextInvalidDisabled = 'inputWithTextInvalidDisabled',
}

const initialValue = {
  [FormFieldId.emptyInput]: undefined,
  [FormFieldId.emptyInputDisabled]: undefined,
  [FormFieldId.inputWithText]: 'Test',
  [FormFieldId.inputWithTextDisabled]: 'Test',
  [FormFieldId.inputWithTextInvalid]: 'Test',
  [FormFieldId.inputWithTextInvalidDisabled]: 'Test',
};

const submitHandler = () => undefined;

const selectInputValidationSchema = yup
  .string()
  .required('Required')
  .test('test', 'Should be not "Test"', value => value !== 'Test');

const formValidationSchema = yup.object({
  [FormFieldId.inputRequired]: selectInputValidationSchema,
  [FormFieldId.inputRequiredDisabled]: selectInputValidationSchema,
  [FormFieldId.inputWithTextInvalid]: selectInputValidationSchema,
  [FormFieldId.inputWithTextInvalidDisabled]: selectInputValidationSchema,
});
